module.exports = __webpack_public_path__ + "aa9c6ca3ec9778aa2a5a4fe88d5bc673.svg";